import { ReportProperties } from './report-properties';
import { UpdateMetadata, PropertyPreviewMetadata, FieldType } from '../_services/report-template-design.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { TemplateDefinition, TemplateText } from './report-template';
import { ReportUnits } from './report-units';
import { TranslateService } from '@ngx-translate/core';
import { LangUpdateService } from '../_services/lang-update.service';
import { FONT_FAMILY } from '../app.constants';

export class ReportFonts extends ReportProperties {

  public onUpdateFontSize: Observable<UpdateMetadata>;
  private onUpdateFontSize$: Subject<UpdateMetadata>;
  public onUpdateFontFamily: Observable<UpdateMetadata>;
  private onUpdateFontFamily$: Subject<UpdateMetadata>;

  private baseDef: TemplateDefinition;
  private units: ReportUnits;

  private readonly metaFontSize = 'fontSize';
  private readonly metaFontFamily = 'fontFamily';

  constructor(templateDef: TemplateDefinition, units: ReportUnits,
    protected translate: TranslateService,
    protected langService: LangUpdateService
) {

    super('Report Font', translate, langService);

    this.units = units;
    this.onUpdateFontSize$ = new Subject();
    this.onUpdateFontSize = this.onUpdateFontSize$.asObservable();
    this.onUpdateFontFamily$ = new Subject();
    this.onUpdateFontFamily = this.onUpdateFontFamily$.asObservable();

    this.baseDef = templateDef;

    this.setChainUpdate();
    this.setPreviewMetadata();
  }

  public getInitailFontSize(): number {
    const rtn: number = this.baseDef.fontSize;
    return rtn;
  }

  public getFontSize(templateDef?: TemplateText): string {
    const rtn: string = (templateDef && templateDef.hasOwnProperty('fontSize') && templateDef.fontSize > 0) ?
      this.units.concatenate('fontSizeUnit', templateDef.fontSize) :
      this.units.concatenate('fontSizeUnit', this.baseDef.fontSize);
    return rtn;
  }

  public getInitialFontFamily(): string {
    const rtn: string = this.baseDef.fontFamily;
    return rtn;
  }

  public getFontFamily(templateDef?: TemplateText): string {
    const rtn: string = (templateDef && templateDef.hasOwnProperty('fontFamily') && templateDef.fontFamily != null) ?
      templateDef.fontFamily :
      this.baseDef.fontFamily;
    return rtn;
  }

  public getTemplateJSON(): TemplateDefinition {
    return this.baseDef;
  }

  protected getPreviewMetadata(): PropertyPreviewMetadata[] {
    return [
      {
        name: this.metaFontSize, parentName: null, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true
      },
      {
        name: this.metaFontFamily, parentName: null, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: FONT_FAMILY,
        isRequired: true,
        isEdited: false,
        isDisplay: true
      }
    ];
  }

  protected setUpdateMetadata(metadata: UpdateMetadata) {
    switch (metadata.name) {
      case this.metaFontSize:
        this.baseDef[metadata.name] = metadata.value as number;
        this.setPreviewValue(metadata.name, metadata.value);
        this.onUpdateFontSize$.next(metadata);
        break;
      case this.metaFontFamily:
        this.baseDef[metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        this.onUpdateFontFamily$.next(metadata);
        break;
    }
  }

  protected setChainUpdateFunction(subscribers: Array<Subscription>) {
    subscribers.push(
      this.units.onUpdateFontSizeUnit.subscribe((metadata: UpdateMetadata) => {
        this.updateProperties({
          id: this.getId(),
          name: this.metaFontSize,
          value: this.convertUnit(this.baseDef.fontSize, metadata.oldValue as string, metadata.value as string),
          oldValue: this.baseDef.fontSize
        });
      })
    );
  }
}
